<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ded"> </p>
<p class="Dedication-ded"><span class="ePub-I">To Dominick J. Di Maio, MD, and Violet Di Maio</span></p>
<p class="Dedication-ded"><span class="ePub-I">My father and mother</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?25ceb1e2